import {ClientAlertForm, ClientCode, VirtualServerInput} from "../../types/clients";
import * as React from "react";

export default function ClientInfo(props: {
  clientName: string
  clientCode: ClientCode
  clientIsActive: boolean
  virtualServerGroupId: string
  virtualServers: ReadonlySet<VirtualServerInput>
  alerts: ReadonlyArray<ClientAlertForm>
  onClientNameChange: (value: string) => void
  onClientCodeChange: (value: string) => void
  onClientIsActiveClicked: (value: boolean) => void
  onClientVirtualServerGroupIdChange: (value: string) => void
}) {
  return (
    <>
      <h2 className='no-margin-top'>
        Client Info{' '}
        {props.virtualServers.size === 0 ||
        props.alerts.filter(
          (alert: ClientAlertForm) =>
            alert.thresholdInPercent === '100' &&
            alert.limitType !== 'RC1_total_clip_size' &&
            alert.contacts.size === 0,
        ).length !== 0 ? (
          <span className='badge badge-breach theme--black-on-white'>
            Missing Configuration Info
          </span>
        ) : (
          <></>
        )}
      </h2>

      <div className="input-group manage-clients-status">
        <label className="status-label">
          Status:
          <span className={`badge ${props.clientIsActive ? 'badge-notify' : 'badge-breach'} theme--base`}>
            {props.clientIsActive ? 'Active' : 'Inactive'}
          </span>
        </label>
        <button
          className={`button no-margin-top status-toggle-button ${props.clientIsActive ? 'button--breach' : ''} theme--black-on-white`}
          type="button"
          onClick={() => props.onClientIsActiveClicked(!props.clientIsActive)}
        >
          {props.clientIsActive ? 'Deactivate' : 'Activate'}
        </button>
      </div>

      <div className='input-group'>
        <label>Client Name</label>
        <input
          placeholder='Client Name'
          className='input'
          value={props.clientName}
          onChange={(event) =>
            props.onClientNameChange(event.currentTarget.value)
          }
          required={true}
        />
      </div>
      <div className='input-group'>
        <label>Client Code</label>
        <input
          value={props.clientCode}
          className='input'
          onChange={(event) =>
            props.onClientCodeChange(event.currentTarget.value)
          }
          placeholder='Client Code'
          required={true}
          maxLength={4}
          minLength={4}
        />
      </div>
      <div className='input-group'>
        <label>Virtual Server Group Id</label>
        <input
          placeholder='Virtual Server Group Id'
          className='input'
          value={props.virtualServerGroupId}
          onChange={(event) =>
            props.onClientVirtualServerGroupIdChange(event.currentTarget.value)
          }
          required={true}
          maxLength={6}
          minLength={6}
        />
      </div>
    </>
  )
}
